import { memo, useMemo } from "react";

import { StatusRequest } from "@/lib/gql/__generated__/graphql";

import { Label } from "@/components/ui/label/label";

import { UpdateStatusRequestDialog } from "../../components";

type Props = {
	statusRequest: StatusRequest;
	canRequestStatusChange: boolean;
	//
	// リクエスト予約を承認する
	onUpdateReservationDetailReservationRequestHandlingAccept: () => Promise<void>;
	// リクエスト予約を非承認する
	onUpdateReservationDetailReservationRequestHandlingReject: () => Promise<void>;
};

export const ReservationStatusOfManagementRequestCompositions = memo(
	({
		statusRequest,
		canRequestStatusChange,
		onUpdateReservationDetailReservationRequestHandlingAccept,
		onUpdateReservationDetailReservationRequestHandlingReject,
	}: Props) => {
		/**
		 * 未処理かどうか
		 */
		const isUnnoticed = useMemo(() => {
			return statusRequest === StatusRequest.Unnoticed;
		}, [statusRequest]);
		/**
		 * 承認済みかどうか
		 */
		const isConfirmed = useMemo(() => {
			return statusRequest === StatusRequest.Confirmed;
		}, [statusRequest]);
		/**
		 * 非承認かどうか
		 */
		const isDeclined = useMemo(() => {
			return statusRequest === StatusRequest.Declined;
		}, [statusRequest]);

		/**
		 * ステータス変更ボタンの表示制御
		 */
		const canShowChangeStatusButton = useMemo(() => {
			return canRequestStatusChange;
		}, [canRequestStatusChange]);

		return (
			<div className="space-y-2">
				<p>予約ステータス</p>

				<div className="flex flex-wrap content-end gap-5">
					<div className="flex flex-wrap items-center gap-2">
						<Label variant={isUnnoticed ? "pink" : "black"} text="新着リクエスト" />

						<Label variant={isConfirmed ? "link" : "black"} text="承認" />

						<Label variant={isDeclined ? "link" : "black"} text="非承認/キャンセル" />
					</div>

					{canShowChangeStatusButton && (
						<UpdateStatusRequestDialog
							onAccept={onUpdateReservationDetailReservationRequestHandlingAccept}
							onReject={onUpdateReservationDetailReservationRequestHandlingReject}
						/>
					)}
				</div>
			</div>
		);
	},
);
